import { DocumentVault } from '../../../guide-messaging/components/DocumentVault';
import type { MembershipDetails } from '../../entityTypes';

interface MembershipDocumentVaultTabPanelProps {
    membershipDetails: MembershipDetails;
}

export const MembershipDocumentVaultTabPanel = ({
    membershipDetails,
}: MembershipDocumentVaultTabPanelProps) => {
    return <DocumentVault membership={membershipDetails} />;
};
